import React from "react";
import Box from "@mui/material/Box";
import { useFormContext } from "react-hook-form";
import { isNumber } from "lodash";
import MDDatePicker from "components/MDDatePicker";
import { displayDate, FALLBACK_DATE_FORMAT } from "utils/Date";
import moment from "moment";

function DatePickerSetting({ setting, setParentState, styles = {}, name, validations = {} }) {
  const {
    formState: { errors },
  } = useFormContext();

  if (validations?.type === "number" && !validations?.validate)
    validations.validate = (value) =>
      (Number(value) && isNumber(Number(value))) || "Please enter a valid number";

  return (
    <Box
      component="form"
      sx={{
        width: "100%",
        marginBottom: "2rem",
        ...styles,
      }}
      noValidate
      autoComplete="off"
    >
      <MDDatePicker
        input={{
          placeholder: "Select a date",
          label: "Match Value",
          value: displayDate(setting.field_value),
          sx: {
            width: "100%",
            "& input": {
              padding: "16px",
            },
          },
        }}
        value={setting.field_value}
        options={{
          parseDate: (dateString) => moment(dateString, FALLBACK_DATE_FORMAT, true).toDate(),
          formatDate: (date) => displayDate(date),
          disableMobile: "true",
        }}
        onChange={(e) => {
          setParentState(e);
        }}
        error={errors[name]?.message || false}
        helperText={errors[name]?.message}
      />
    </Box>
  );
}

export default DatePickerSetting;
